import SopraSteriaIcon from './sopra-steria-icon';
export default SopraSteriaIcon;